import * as actionTypes from "./actionTypes";



export const loadVendingCategory = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY,
    data
  };
};

export const loadVendingCategorySuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_SUCCESS,
    data
  };
};

export const loadVendingCategoryFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_FAIL
  };
};


export const loadVendingCategoryAll = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_ALL,
    data
  };
};

export const loadVendingCategoryAllSuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_ALL_SUCCESS,
    data
  };
};

export const loadVendingCategoryAllFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_ALL_FAIL
  };
};


export const addVendingCategory = data => {
  return {
    type: actionTypes.ADD_VENDING_CATEGORY,
    data
  };
};

export const addVendingCategorySuccess = () => {
  return {
    type: actionTypes.ADD_VENDING_CATEGORY_SUCCESS
  };
};

export const addVendingCategoryFail = () => {
  return {
    type: actionTypes.ADD_VENDING_CATEGORY_FAIL
  };
};

export const editVendingCategory = (id,data) => {
  return {
    type: actionTypes.EDIT_VENDING_CATEGORY,
    id,
    data
  };
};

export const editVendingCategorySuccess = () => {
  return {
    type: actionTypes.EDIT_VENDING_CATEGORY_SUCCESS
  };
};

export const editVendingCategoryFail = () => {
  return {
    type: actionTypes.EDIT_VENDING_CATEGORY_FAIL
  };
};

export const deleteVendingCategory = (id, data) => {
  return {
    type: actionTypes.DELETE_VENDING_CATEGORY,
    id,
    data
  };
};

export const deleteVendingCategorySuccess = () => {
  return {
    type: actionTypes.DELETE_VENDING_CATEGORY_SUCCESS
  };
};

export const deleteVendingCategoryFail = () => {
  return {
    type: actionTypes.DELETE_VENDING_CATEGORY_FAIL
  };
};





export const loadVendingCategoryEffectiveDateList = data => {

  return {
    type: actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST,
    data
  };
};

export const loadVendingCategoryEffectiveDateListSuccess = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST_SUCCESS,
    data
  };
};

export const loadVendingCategoryEffectiveDateListFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST_FAIL
  };
};




export const vendingCategoryPriceControlLoad = (data) => {
  return {
    type: actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD,
    data
  };
};

export const vendingCategoryPriceControlLoadSuccess = (data) => {
  return {
    type: actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD_SUCCESS,
    data
  };
};

export const vendingCategoryPriceControlLoadFail = () => {
  return {
    type: actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD_FAIL
  };
};

export const vendingCategoryPriceControlSet = (id, data) => {
  return {
    type: actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET,
    id,
    data
  };
};

export const vendingCategoryPriceControlSetSuccess = () => {
  return {
    type: actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET_SUCCESS
  };
};

export const vendingCategoryPriceControlSetFail = () => {
  return {
    type: actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET_FAIL
  };
};


export const vendingCategoryPriceRemove = (id,data) => {
  return {
    type: actionTypes.DELETE_VENDING_CATEGORY_PRICE,
    id,
    data
  };
};

export const vendingCategoryPriceRemoveSuccess = (data) => {
  return {
    type: actionTypes.DELETE_VENDING_CATEGORY_PRICE_SUCCESS,
    data
  };
};

export const vendingCategoryPriceRemoveFail = () => {
  return {
    type: actionTypes.DELETE_VENDING_CATEGORY_PRICE_FAIL
  };
};


export const getVendingCategoryPricePDF = (data) => {
  return {
    type: actionTypes.GET_VENDING_CATEGORY_PRICE_PDF,
    data,
  };
};

export const getVendingCategoryPricePDFSuccess = data => {
  return {
    type: actionTypes.GET_VENDING_CATEGORY_PRICE_PDF_SUCCESS,
    data
  };
};

export const getVendingCategoryPricePDFFail = () => {
  return {
    type: actionTypes.GET_VENDING_CATEGORY_PRICE_PDF_FAIL
  };
};



/** Grader Vending **/
export const graderVendingCount = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_COUNT,
    data
  };
};

export const graderVendingCountSuccess = data => {
  return {
    type: actionTypes.GRADER_VENDING_COUNT_SUCCESS,
    data
  };
};

export const graderVendingCountFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_COUNT_FAIL
  };
};

export const loadGraderVendingList = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_LIST,
    data
  };
};

export const loadGraderVendingListSuccess = data => {
  return {
    type: actionTypes.GRADER_VENDING_LIST_SUCCESS,
    data
  };
};

export const loadGraderVendingListFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_LIST_FAIL
  };
};

export const loadGraderVendingLocationList = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_LOCATION_LIST,
    data
  };
};

export const loadGraderVendingLocationListSuccess = data => {
  return {
    type: actionTypes.GRADER_VENDING_LOCATION_LIST_SUCCESS,
    data
  };
};

export const loadGraderVendingLocationListFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_LOCATION_LIST_FAIL
  };
};

export const loadGraderVendingBagList = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_LIST,
    data
  };
};

export const loadGraderVendingBagListSuccess = data => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_LIST_SUCCESS,
    data
  };
};

export const loadGraderVendingBagListFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_LIST_FAIL
  };
};

export const vendingBagCount = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_COUNT,
    data
  };
};

export const vendingBagCountSuccess = data => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_COUNT_SUCCESS,
    data
  };
};

export const vendingBagCountFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_COUNT_FAIL
  };
};

export const vendingBagRollbackOverflow = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW,
    id,
    data
  };
};

export const vendingBagRollbackOverflowSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW_SUCCESS
  };
};

export const vendingBagRollbackOverflowFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW_FAIL
  };
};

export const vendingBagConfirmTripFilling = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING,
    id,
    data
  };
};

export const vendingBagConfirmTripFillingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING_SUCCESS
  };
};

export const vendingBagConfirmTripFillingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING_FAIL
  };
};

export const vendingBagForceTripFilling = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING,
    id,
    data
  };
};

export const vendingBagForceTripFillingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING_SUCCESS
  };
};

export const vendingBagForceTripFillingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING_FAIL
  };
};


export const graderVendingDeviceStatusList = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST,
    id,
    data
  };
};

export const graderVendingDeviceStatusListSuccess = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST_SUCCESS,
    data
  };
};

export const graderVendingDeviceStatusListFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST_FAIL
  };
};


export const graderVendingUploadedLogsList = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST,
    data
  };
};

export const graderVendingUploadedLogsListSuccess = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST_SUCCESS,
    data
  };
};

export const graderVendingUploadedLogsListFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST_FAIL
  };
};

export const errorLogsResolved = (id, data) => {
  return {
    type: actionTypes.ERROR_LOG_RESOLVED,
    id, 
    data
  };
};

export const errorLogsResolvedSuccess = (data) => {
  return {
    type: actionTypes.ERROR_LOG_RESOLVED_SUCCESS,
    data
  };
};

export const errorLogsResolvedFail = () => {
  return {
    type: actionTypes.ERROR_LOG_RESOLVED_FAIL
  };
};


export const graderVendingDetail = (id,data) => {
  return {
    type: actionTypes.GRADER_VENDING_DETAIL,
    data,
    id
  };
};

export const graderVendingDetailSuccess = data => {
  return {
    type: actionTypes.GRADER_VENDING_DETAIL_SUCCESS,
    data
  };
};

export const graderVendingDetailFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_DETAIL_FAIL
  };
};


export const approveGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_APPROVE,
    id,
    data
  };
};

export const approveGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_APPROVE_SUCCESS
  };
};

export const approveGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_APPROVE_FAIL
  };
};

export const addGraderVending = (grader, data) => {
  return {
    type: actionTypes.GRADER_VENDING_CREATE,
    grader,
    data
  };
};

export const addGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_CREATE_SUCCESS
  };
};

export const addGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_CREATE_FAIL
  };
};


export const editGraderVending = (id, grader, data) => {
  return {
    type: actionTypes.GRADER_VENDING_EDIT,
    id,
    grader, 
    data
  };
};

export const editGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_EDIT_SUCCESS
  };
};

export const editGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_EDIT_FAIL
  };
};

export const resetPwdGraderVending = (id, grader, data) => {
  return {
    type: actionTypes.GRADER_VENDING_RESET_PWD,
    id,
    grader, 
    data
  };
};

export const resetPwdGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_RESET_PWD_SUCCESS
  };
};

export const resetPwdGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_RESET_PWD_FAIL
  };
};

export const deleteGraderVending = (id, grader, data) => {
  return {
    type: actionTypes.GRADER_VENDING_REMOVE,
    id,
    grader, 
    data
  };
};

export const deleteGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_REMOVE_SUCCESS
  };
};

export const deleteGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_REMOVE_FAIL
  };
};

export const publishGraderVending = (id, grader, data) => {
  return {
    type: actionTypes.GRADER_VENDING_PUBLISH,
    id,
    grader,
    data
  };
};

export const publishGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_PUBLISH_SUCCESS
  };
};

export const publishGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_PUBLISH_FAIL
  };
};

export const residentOnlyGraderVending = (id, grader, data) => {
  return {
    type: actionTypes.GRADER_VENDING_RESIDENT_ONLY,
    id,
    grader,
    data
  };
};

export const residentOnlyGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_RESIDENT_ONLY_SUCCESS
  };
};

export const residentOnlyGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_RESIDENT_ONLY_FAIL
  };
};

export const rebootGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_REBOOT,
    id,
    data
  };
};

export const rebootGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_REBOOT_SUCCESS
  };
};

export const rebootGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_REBOOT_FAIL
  };
};

export const unlockMaglockGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK,
    id,
    data
  };
};

export const unlockMaglockGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK_SUCCESS
  };
};

export const unlockMaglockGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK_FAIL
  };
};

export const currentStatusGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_STATUS,
    id,
    data
  };
};

export const currentStatusGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_STATUS_SUCCESS
  };
};

export const currentStatusGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_STATUS_FAIL
  };
};

// command: "light/on" | "light/off" | "lid/open" | "lid/close"
export const controlBoardGraderVending = (id, command, data) => {
  return {
    type: actionTypes.GRADER_VENDING_CONTROL_BOARD,
    id,
    command,
    data
  };
};

export const controlBoardGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_CONTROL_BOARD_SUCCESS
  };
};

export const controlBoardGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_CONTROL_BOARD_FAIL
  };
};

export const stopGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_STOP_SERVICE,
    id,
    data
  };
};

export const stopGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_STOP_SERVICE_SUCCESS
  };
};

export const stopGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_STOP_SERVICE_FAIL
  };
};

export const startGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_START_SERVICE,
    id,
    data
  };
};

export const startGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_START_SERVICE_SUCCESS
  };
};

export const startGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_START_SERVICE_FAIL
  };
};

export const testConnectionGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_TEST_CONNECTION,
    id,
    data
  };
};

export const testConnectionGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_TEST_CONNECTION_SUCCESS
  };
};

export const testConnectionGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_TEST_CONNECTION_FAIL
  };
};

export const currentWeightGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_WEIGHT,
    id,
    data
  };
};

export const currentWeightGraderVendingSuccess = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_WEIGHT_SUCCESS,
    data
  };
};

export const currentWeightGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_WEIGHT_FAIL
  };
};

export const currentSnapshotGraderVending = (id, data) => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_SNAPSHOT,
    id,
    data
  };
};

export const currentSnapshotGraderVendingSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_SNAPSHOT_SUCCESS
  };
};

export const currentSnapshotGraderVendingFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_CURRENT_SNAPSHOT_FAIL
  };
};

export const vendingLandfillDistance = (id, data) => {
  return {
    type: actionTypes.VENDING_LANDFILL_DISTANCE,
    id,
    data
  };
};

export const vendingLandfillDistanceSuccess = (data) => {
  return {
    type: actionTypes.VENDING_LANDFILL_DISTANCE_SUCCESS,
    data
  };
};

export const vendingLandfillDistanceFail = () => {
  return {
    type: actionTypes.VENDING_LANDFILL_DISTANCE_FAIL
  };
};

export const audioTTList = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD,
    data
  };
};

export const audioTTListSuccess = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD_SUCCESS,
    data
  };
};

export const audioTTListFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD_FAIL
  };
};

export const audioTTSUpdate = (data) => {
  return {
    type: actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE,
    data
  };
};

export const audioTTSUpdateSuccess = () => {
  return {
    type: actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE_SUCCESS
  };
};

export const audioTTSUpdateFail = () => {
  return {
    type: actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE_FAIL
  };
};

export const resetMQTTTopic = (data) => {
  return {
    type: actionTypes.RESET_MQTT_TOPIC,
    data
  };
};

export const resetMQTTTopicSuccess = () => {
  return {
    type: actionTypes.RESET_MQTT_TOPIC_SUCCESS
  };
};

export const resetMQTTTopicFail = () => {
  return {
    type: actionTypes.RESET_MQTT_TOPIC_FAIL
  };
};

export const cancelStuckExpressOrder = (id, data) => {
  return {
    type: actionTypes.CANCEL_STUCK_EXPRESS_ORDER,
    id, 
    data
  };
};

export const cancelStuckExpressOrderSuccess = () => {
  return {
    type: actionTypes.CANCEL_STUCK_EXPRESS_ORDER_SUCCESS
  };
};

export const cancelStuckExpressOrderFail = () => {
  return {
    type: actionTypes.CANCEL_STUCK_EXPRESS_ORDER_FAIL
  };
};



/* ===== DRVM DASHBOARD===== */
export const loadDRVMGradingOrderDashboard = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD,
    data
  };
};

export const loadDRVMGradingOrderDashboardSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD_SUCCESS,
    data
  };
};

export const loadDRVMGradingOrderDashboardFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD_FAIL
  };
};

export const loadDRVMGradingVendingDashboard = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD,
    data
  };
};

export const loadDRVMGradingVendingDashboardSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD_SUCCESS,
    data
  };
};

export const loadDRVMGradingVendingDashboardFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD_FAIL
  };
};


export const loadDRVMGradingStatusChart = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_STATUS_CHART,
    data
  };
};

export const loadDRVMGradingStatusChartSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_STATUS_CHART_SUCCESS,
    data
  };
};

export const loadDRVMGradingStatusChartFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_STATUS_CHART_FAIL
  };
};


export const loadDRVMGradingOrderChart = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_ORDER_CHART,
    data
  };
};

export const loadDRVMGradingOrderChartSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_ORDER_CHART_SUCCESS,
    data
  };
};

export const loadDRVMGradingOrderChartFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_ORDER_CHART_FAIL
  };
};


export const loadDRVMGradingRanking = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_RANKING,
    data
  };
};

export const loadDRVMGradingRankingSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_RANKING_SUCCESS,
    data
  };
};

export const loadDRVMGradingRankingFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_RANKING_FAIL
  };
};


export const loadDRVMGradingCategoryChart = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART,
    data
  };
};

export const loadDRVMGradingCategoryChartSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART_SUCCESS,
    data
  };
};

export const loadDRVMGradingCategoryChartFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART_FAIL
  };
};
/* ===== END DRVM DASHBOARD===== */


/* ===== VENDING COUNCIL ===== */
export const vendingCouncilList = data => {
  return {
    type: actionTypes.VENDING_COUNCIL_LIST,
    data
  };
};

export const vendingCouncilListSuccess = data => {
  return {
    type: actionTypes.VENDING_COUNCIL_LIST_SUCCESS,
    data
  };
};

export const vendingCouncilListFail = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_LIST_FAIL
  };
};

export const vendingCouncilCreate = data => {
  return {
    type: actionTypes.VENDING_COUNCIL_CREATE,
    data
  };
};

export const vendingCouncilCreateSuccess = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_CREATE_SUCCESS
  };
};

export const vendingCouncilCreateFail = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_CREATE_FAIL
  };
};

export const vendingCouncilUpdate = (id, data) => {
  return {
    type: actionTypes.VENDING_COUNCIL_UPDATE,
    id,
    data
  };
};

export const vendingCouncilUpdateSuccess = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_UPDATE_SUCCESS
  };
};

export const vendingCouncilUpdateFail = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_UPDATE_FAIL
  };
};

export const vendingCouncilRemove = (id, data) => {
  return {
    type: actionTypes.VENDING_COUNCIL_REMOVE,
    id,
    data
  };
};

export const vendingCouncilRemoveSuccess = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_REMOVE_SUCCESS
  };
};

export const vendingCouncilRemoveFail = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_REMOVE_FAIL
  };
};

export const vendingCouncilSet = data => {
  return {
    type: actionTypes.VENDING_COUNCIL_SET,
    data
  };
};

export const vendingCouncilSetSuccess = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_SET_SUCCESS
  };
};

export const vendingCouncilSetFail = () => {
  return {
    type: actionTypes.VENDING_COUNCIL_SET_FAIL
  };
};
/* ===== END VENDING COUNCIL ===== */


/* ===== VENDING VERSION ===== */
export const vendingVersionList = data => {
  return {
    type: actionTypes.VENDING_VERSION_LIST,
    data
  };
};

export const vendingVersionListSuccess = data => {
  return {
    type: actionTypes.VENDING_VERSION_LIST_SUCCESS,
    data
  };
};

export const vendingVersionListFail = () => {
  return {
    type: actionTypes.VENDING_VERSION_LIST_FAIL
  };
};

export const vendingVersionUpload = (data, onUploadProgress) => {
  return {
    type: actionTypes.VENDING_VERSION_UPLOAD,
    data,
    onUploadProgress
  };
};

export const vendingVersionUploadSuccess = () => {
  return {
    type: actionTypes.VENDING_VERSION_UPLOAD_SUCCESS
  };
};

export const vendingVersionUploadFail = () => {
  return {
    type: actionTypes.VENDING_VERSION_UPLOAD_FAIL
  };
};

export const vendingVersionSelect = (id, data) => {
  return {
    type: actionTypes.VENDING_VERSION_SELECT,
    id,
    data
  };
};

export const vendingVersionSelectSuccess = () => {
  return {
    type: actionTypes.VENDING_VERSION_SELECT_SUCCESS
  };
};

export const vendingVersionSelectFail = () => {
  return {
    type: actionTypes.VENDING_VERSION_SELECT_FAIL
  };
};

export const vendingVersionSend = (id, data) => {
  return {
    type: actionTypes.VENDING_VERSION_SEND,
    id,
    data
  };
};

export const vendingVersionSendSuccess = () => {
  return {
    type: actionTypes.VENDING_VERSION_SEND_SUCCESS
  };
};

export const vendingVersionSendFail = () => {
  return {
    type: actionTypes.VENDING_VERSION_SEND_FAIL
  };
};

export const vendingVersionRemove = (id, data) => {
  return {
    type: actionTypes.VENDING_VERSION_REMOVE,
    id,
    data
  };
};

export const vendingVersionRemoveSuccess = () => {
  return {
    type: actionTypes.VENDING_VERSION_REMOVE_SUCCESS
  };
};

export const vendingVersionRemoveFail = () => {
  return {
    type: actionTypes.VENDING_VERSION_REMOVE_FAIL
  };
};
/* ===== END VENDING VERSION ===== */


/* ===== CATEGORY AI RULES ===== */
export const loadDRVMRecyclingCategory = (data) => {
  return {
    type: actionTypes.LOAD_DRVM_RECYCLING_CATEGORY,
    data
  };
};

export const loadDRVMRecyclingCategorySuccess = data => {
  return {
    type: actionTypes.LOAD_DRVM_RECYCLING_CATEGORY_SUCCESS,
    data
  };
};

export const loadDRVMRecyclingCategoryFail = () => {
  return {
    type: actionTypes.LOAD_DRVM_RECYCLING_CATEGORY_FAIL
  };
};

export const updateCategoryRules = (id, data) => {
  return {
    type: actionTypes.UPDATE_CATEGORY_RULES,
    id,
    data
  };
};

export const updateCategoryRulesSuccess = () => {
  return {
    type: actionTypes.UPDATE_CATEGORY_RULES_SUCCESS
  };
};

export const updateCategoryRulesFail = () => {
  return {
    type: actionTypes.UPDATE_CATEGORY_RULES_FAIL
  };
};
/* ===== END CATEGORY AI RULES ===== */
